export default __webpack_public_path__ + "assets/images/ba895001f053ff0dce634e38ea9d1964.svg";